import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

const Material = (props) => {
    return (
        <SvgIcon {...props} fill="none">
            <circle cx="7" cy="7" r="6" stroke="black" strokeWidth="2" />
            <line x1="1.29289" y1="9.07106" x2="9.07107" y2="1.29289" stroke="black" strokeWidth="2" />
            <path d="M3.29289 12.0711L11.864 3.49999" stroke="black" strokeWidth="2" />
            <path d="M9 7L11.7374 9.73743" stroke="black" strokeWidth="2" />
            <path d="M6 9L9 12" stroke="black" strokeWidth="2" />
        </SvgIcon>
    );
}

Material.defaultProps = {
    viewBox: '0 0 16 16'
};

export default Material;

